import React, { useMemo, useState } from "react";
import Policy from "../../components/Operations/Policy";
import Users from "../../components/Operations/Users";
import CIS from "../../components/Operations/CIS/CIS";
import PSM_Matrix from "../../containers/PSM_Matrix";
import EDC_Matrix from "../../containers/EDC_Matrix";
import PSMLogs from "../PSM_Matrix/PSMLogs";
import { hasPermission } from "../../components/Permissions";

const getDefaultTab = () => {
  if (hasPermission("POLICY")) return "POLICY";
  if (hasPermission("USERS")) return "USERS";
  return "CIS";
};

const Operations = () => {
  const [activeTab, setActiveTab] = useState(getDefaultTab);

  const tabs = useMemo(() => {
    const items = [];

    if (hasPermission("POLICY")) {
      items.push({ key: "POLICY", label: "Policy", Component: Policy });
    }

    if (hasPermission("USERS")) {
      items.push({ key: "USERS", label: "Users", Component: Users });
    }

    items.push({ key: "CIS", label: "CIS Regenerate", Component: CIS });
    items.push({ key: "PSM", label: "PSM Matrix", Component: PSM_Matrix });
    items.push({ key: "EDC", label: "EDC Matrix", Component: EDC_Matrix });

    if (window.envType === "DEV" || window.envType === "NEWGEN-UAT") {
      items.push({ key: "PSMLOGS", label: "PSM Logs", Component: PSMLogs });
    }

    return items;
  }, []);

  const activeItem = tabs.find((tab) => tab.key === activeTab) || tabs[0];
  const ActiveComponent = activeItem?.Component;

  const renderTab = (tab) => {
    const isSelected = activeTab === tab.key;

    return (
      <div
        key={tab.key}
        role="button"
        tabIndex={0}
        onClick={() => setActiveTab(tab.key)}
        onKeyDown={(event) => {
          if (event.key === "Enter" || event.key === " ") {
            setActiveTab(tab.key);
          }
        }}
        className={`view-count proposal-dashboard__filter-card operations-page__tab ${
          isSelected ? "selected" : ""
        }`}
      >
        <span className="proposal-dashboard__filter-label">{tab.label}</span>
      </div>
    );
  };

  return (
    <div className="proposal-dashboard operations-page">
      <div className="proposal-dashboard__header operations-page__header">
        <h2 className="proposal-dashboard__title">Operations</h2>
        <p className="proposal-dashboard__subtitle">
          Policy management, user access, CIS regeneration, and matrix
          configuration
        </p>
      </div>

      <div className="view-options proposal-dashboard__filters operations-page__tabs">
        {tabs.map(renderTab)}
      </div>

      <div className="operations-page__content">
        {ActiveComponent && <ActiveComponent />}
      </div>
    </div>
  );
};

export default Operations;
